import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {RegistrationModule} from './registration/registration.module';
import {SharedModule} from './shared/shared.module';
import { LoginModule } from './login/login.module';
import {TroubleSigningInModule} from './trouble-signing-in/trouble-signing-in.module';
import {ResetPasswordModule} from './reset-password/reset-password.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RegistrationModule,
    SharedModule,
    LoginModule,
    TroubleSigningInModule,
    ResetPasswordModule,
    SharedModule
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
